import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Box, Stack, Alert } from "@mui/material";

const StackedSnackbar = forwardRef(({ autoHideDuration = 3000 }, ref) => {
  const [snackBarPopups, setSnackbarPopups] = useState([]);

  useImperativeHandle(ref, () => ({
    addSnackbar: (popup) => {
      setSnackbarPopups((prev) => [...prev, popup]);
    },
  }));

  useEffect(() => {
    if (snackBarPopups.length > 0) {
      const first = snackBarPopups[0];
      if (!first.persist) {
        const timer = setTimeout(() => {
          setSnackbarPopups((prev) => prev.slice(1));
        }, autoHideDuration);
        return () => clearTimeout(timer);
      }
    }
  }, [snackBarPopups, autoHideDuration]);

  if (snackBarPopups.length === 0) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 16,
        left: 16,
        zIndex: 7300,
        width: 400,
      }}
    >
      <Stack spacing={2}>
        {snackBarPopups.map((popup, idx) => (
          <Alert
            key={idx}
            severity={popup.type}
            sx={{ width: "100%" }}
            onClose={() => {
              setSnackbarPopups((prev) => prev.filter((_, i) => i !== idx));
            }}
          >
            {popup.message}
          </Alert>
        ))}
      </Stack>
    </Box>
  );
});

export default StackedSnackbar;
